<template>
  <div class="kitchen-frame">
    <Content :routeArr="routeArr" />

    <div class="box">
      <div class="m-title" v-if="isMobile == 1">{{ $store.state.name }}</div>
      <div class="news-box">
        <div class="ul">
          <el-card class="kit-card" v-for="item in newsList" :key="item.id">
            <div class="title-box" @click="getDetail(item)">
              <img class="title-img" :src="URL + item.newsImageUrl" alt="" />
              <div class="desc">{{ item.title }}</div>
            </div>
          </el-card>
        </div>
        <div class="empty" v-show="newsList.length == 0">
          当前暂无相关菜品推荐~
        </div>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="params.pageIndex"
          :page-sizes="[12, 24, 36, 48]"
          :page-size="params.pageSize"
          :layout="!isMobile ? layoutPc : layoutM"
          :total="allLen"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Content from "@/components/content.vue";

import { sysNewsList } from "../../util/news/news.js";
import { URL } from "../../util/config";
export default {
  data() {
    return {
      URL,
      params: {
        pageIndex: 1,
        pageSize: 12,
        newsCode: "",
        typeCode: "",
      },
      newsList: [],
      allLen: 0,
      nowNew: {},
      routeArr: [],
      preNew: {},
      nextNew: {},
      getNewIng: false,
      isMobile: sessionStorage.getItem("isMobile"),
      layoutPc: "total, sizes, prev, pager, next",
      layoutM: "total, prev, pager, next",
    };
  },
  components: {
    Content,
  },
  created() {},
  mounted() {
    this.params.newsCode = this.$store.state.code;
    this.getList();

    this.routeArr = [
      { name: "首页", path: "/" },
      { name: this.$store.state.name, path: "/kitchen" },
    ];
  },
  methods: {
    getList() {
      //获取列表
      sysNewsList(this.params).then((res) => {
        if (res.code === 0) {
          this.newsList = res.data.list;
          this.allLen = res.data.total;
        }
      });
    },
    getDetail(item) {
      this.$router.push(
        "/kitDetail?id=" + item.id + "&num=" + this.params.pageIndex
      );
    },
    handleSizeChange(val) {
      this.params.pageSize = Number(val);
      this.getList();
    },
    handleCurrentChange(val) {
      this.params.pageIndex = Number(val);
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
@function pxToRem($args) {
  @return $args / 50 + rem;
}

.kitchen-frame {
  .box {
    width: 1200px;
    margin: 60px auto;

    .m-title {
      font-size: pxToRem(20);
      line-height: pxToRem(50);
      margin-bottom: pxToRem(20);
      font-weight: bold;
      color: #cc0f16;
      text-align: center;
      position: relative;
      &::after {
        content: "";
        display: block;
        width: pxToRem(40);
        height: 1px;
        background-color: $theme;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
      }
    }

    .el-pagination {
      text-align: center;
      margin-top: 30px;
    }

    .ul {
      display: flex;
      flex-wrap: wrap;

      .kit-card {
        margin-right: 10px;
        margin-bottom: 10px;

        &:nth-child(4n) {
          margin-right: 0;
        }
      }
    }

    .kit-card {
      &:hover {
        cursor: pointer;

        .desc {
          color: $theme;
        }
      }
    }

    .empty {
      text-align: center;
      margin-bottom: 50px;
    }

    .title-img {
      width: 290px;
      height: 200px;
      display: block;
    }
    .desc {
      text-align: center;
      padding: 10px 0;
    }
  }
}

@media (max-width: 1300px) {
  .kitchen-frame .box {
    width: 1000px;

    .ul {
      .kit-card {
        margin-right: 30px;
      }
    }
  }
}

@media (max-width: 1024px) {
  .kitchen-frame .box {
    width: 100%;
    margin: 0 0 pxToRem(30);
    padding: 0 pxToRem(20);
    box-sizing: border-box;

    .title-img {
      width: pxToRem(160);
      height: pxToRem(110);
    }
    .desc {
      font-size: pxToRem(14);
    }
    .ul {
      justify-content: space-between;

      .kit-card {
        margin-right: 0;
      }
    }
  }
}
</style>
